import React from "react";
import styled from "styled-components";
import ModelItem from './ModelItem';

const DedicatedTeam = ({dedicatedamodelData}) => {
  return (
    <DedicatedTeamModel>

      {
        dedicatedamodelData.map((item)=>(
          <ModelItem data={item} />
        ))
      }
 
    </DedicatedTeamModel>
  );
};


const DedicatedTeamModel = styled.div`
  margin-top: 3rem;
  @media (max-width: 980px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;




export default DedicatedTeam;
